import { render } from "./IqraTeacherWeeklySchedule.vue?vue&type=template&id=6d9498e9&scoped=true"
import script from "./IqraTeacherWeeklySchedule.vue?vue&type=script&lang=js"
export * from "./IqraTeacherWeeklySchedule.vue?vue&type=script&lang=js"

import "./IqraTeacherWeeklySchedule.vue?vue&type=style&index=0&id=6d9498e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9498e9"]])

export default __exports__